export const APP_BAR_MOBILE = 64;
export const APP_BAR_DESKTOP = 74;
export const OUTDOOR_GYM_EQUIPMENT_ID = '01H5VJ8AXWBRCAYCPDXWDF8KXM';

export const responsiveMargin = { xs: 2.5, sm: 8, lg: 16, xl: 32 };
export const responsiveSpacing = { xs: 2, md: 3.5 };

export enum InspectionStatusList {
  INSPECTION_NEED = 'INSPECTION_NEED',
  INSPECTED = 'INSPECTED',
  INSPECTION_NOT_REQUIRED = 'INSPECTION_NOT_REQUIRED',
}
export const InspectionStatusListLabel = {
  [InspectionStatusList.INSPECTION_NEED]: '점검전',
  [InspectionStatusList.INSPECTED]: '점검완료',
  [InspectionStatusList.INSPECTION_NOT_REQUIRED]: '일반시설물',
};

export enum InspectionScoreList {
  A = 'A',
  B = 'B',
  C = 'C',
}

export const InspectionScoreListLabel = {
  [InspectionScoreList.A]: '양호',
  [InspectionScoreList.B]: '주의',
  [InspectionScoreList.C]: '불량',
};

export const FacilityFormMode = {
  SPORTING_GOODS: 'SPORTING_GOODS',
  REST: 'REST',
};

export enum UserRoleList {
  MANAGER = 'MANAGER',
  USER = 'USER',
}
export const UserRoleListLabel = {
  [UserRoleList.MANAGER]: '관리자',
  [UserRoleList.USER]: '사용자',
};

export enum CategoryTypeList {
  REGULAR = 'REGULAR',
  OUTDOOR_GYM_EQUIPMENT = 'OUTDOOR_GYM_EQUIPMENT',
}
export const CategoryTypeListLabel = {
  [CategoryTypeList.REGULAR]: '그외 시설',
  [CategoryTypeList.OUTDOOR_GYM_EQUIPMENT]: '야외운동기구',
};

export enum SubCategoryTypeList {
  SINGULAR = 'SINGULAR',
  COMPOSITE = 'COMPOSITE',
}

export const SubCategoryTypeListLabel = {
  [SubCategoryTypeList.SINGULAR]: '일반형 운동기구',
  [SubCategoryTypeList.COMPOSITE]: '복합형 운동기구',
};

export enum OwnershipTypeList {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export const OwnershipTypeListLabel = {
  [OwnershipTypeList.PRIVATE]: '사유지',
  [OwnershipTypeList.PUBLIC]: '공공용지',
};
